<template>
  <div class="do-public">
    <div class="do-public__header">
      <div id="logo">
        <span class="icon-docendo" id="d-icon"></span>
      </div>
      <h4>{{ calendarName }}</h4>
    </div>
    <div class="do-public__body">
      <div class="do-spinner__container" v-if="!calendar">
        <div class="do-spinner do-spinner--large"></div>
      </div>
      <div v-else>
        <SmartScreen :calendarId="calendarId"></SmartScreen>
      </div>
      <!--
      <DCalendar
        :calendarId="calendarId"
        :events="events"
        :isLoadingEvents="isLoadingEvents">
      </DCalendar>
      -->
    </div>
  </div>
</template>

<script>
import docendo from '../../../docendo'
import moment from 'moment'
import DCalendar from '../../DCalendar/DCalendar'
import SmartScreen from './SmartScreen.vue'

export default {
  components: {DCalendar, SmartScreen},
  props: {
    calendarId: {},
    calendar: {
      default: null
    }
  },
  data () {
    return {
      startDate: moment().startOf('isoWeek'),
      endDate: moment().endOf('isoWeek'),
      events: [],
      isLoadingEvents: false
    }
  },
  computed: {
    calendarName () {
      return this.calendar ? this.calendar.name : ''
    }
  },
  methods: {
    getCalendarEvents () {
      this.isLoadingEvents = true
      docendo.publicEventsFromCalendar(this.calendarId, this.startDate, this.endDate, success => {
        this.events = success && success.length > 0 ? JSON.parse(success) : []
        this.isLoadingEvents = false
      }, failure => {
        console.log({failure})
      })
    }
  },
  mounted () {
    this.getCalendarEvents()
  }
}
</script>

<style scoped>

.do-public {
  font-size: 16px;
}

.do-public__header {
  display: flex;
  height: 55px;
  align-items: stretch;
  gap: 1rem;
  background-color: #fff;
  color: var(--grey);
  box-shadow: 0 0.08rem 0.34rem -0.125rem;
  z-index: 999;
}

.do-public__header h4 {
  line-height: 55px;
}

#logo {
  flex: 1;
  position: relative;
  z-index: 1010;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 45px;
  min-width: 55px;
  max-width: 55px;
  color: #fff;
  background: linear-gradient(90deg, #4553ff, #7f7fd5);
  text-decoration: none !important;
  transition: all .25s;
  cursor: default;
}

.do-spinner__container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2rem auto;
}
</style>



// WEBPACK FOOTER //
// DesktopVue.vue?336cf90a